__turbopack_context__.v({
  "app_light_theme": "ProductCard-module-scss-module__4Herva__app_light_theme",
  "root": "ProductCard-module-scss-module__4Herva__root",
  "top_controller__item": "ProductCard-module-scss-module__4Herva__top_controller__item",
  "unavailable_text": "ProductCard-module-scss-module__4Herva__unavailable_text",
});
